import { DatabaseModel } from './database-model';
import { ModelJson } from './database-model';
import { Media } from './media';

export enum FeaturedTheme {
    dark_bg = "dark_bg",
    light_bg = "light_bg"
}

export class FeaturedTour extends DatabaseModel {
    public key: string = null;
    // Reference to the tour that the feature represents
    public tourKey: string = null;
    // Banner image for mobile
    public desktopBannerMedia: Media = new Media();
    // Title image for desktop (to appear on top of banner)
    public desktopTitleMedia: Media = new Media();
    // Banner image for mobile
    public mobileBannerMedia: Media = new Media();
    // Title image for mobile (to appear on top of banner)
    public mobileTitleMedia: Media = new Media();
    // Theme to set text and button colors on banner (decided by light/darkness of banner image)
    public theme: FeaturedTheme = FeaturedTheme.dark_bg;
    // Published decided whether featured tour appears in tours page
    public published: boolean = false;
    // The order of appearance in tours page
    public order: number = -1;

    constructor(key?: string, json?: ModelJson) {
        super();
        if(json) this.fromJson(json);
        // Automatically assign keys to new objects
        if(!this.key) this.key = key || DatabaseModel.genKey();
    }

    /**
     * Convert database json to FeaturedTour instance (deserialize)
     */
    public fromJson(json): FeaturedTour {
        Object.assign(this, json);
        this.desktopBannerMedia = json.desktopBannerMedia ? new Media(json.desktopBannerMedia, json.desktopBannerMedia.key) : new Media();;
        this.desktopTitleMedia = json.desktopTitleMedia ? new Media(json.desktopTitleMedia, json.desktopTitleMedia.key) : new Media();;
        this.mobileBannerMedia = json.mobileBannerMedia ? new Media(json.mobileBannerMedia, json.mobileBannerMedia.key) : new Media();;
        this.mobileTitleMedia = json.mobileTitleMedia ? new Media(json.mobileTitleMedia, json.mobileTitleMedia.key) : new Media();;
        this.theme = json.theme || FeaturedTheme.dark_bg;
        return this;
    }

    /**
     * Convert FeaturedTour instance to json (serialize)
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        json.desktopBannerMedia = this.desktopBannerMedia ? this.desktopBannerMedia.toJson() : null;
        json.desktopTitleMedia = this.desktopTitleMedia ? this.desktopTitleMedia.toJson() : null;
        json.mobileBannerMedia = this.mobileBannerMedia ? this.mobileBannerMedia.toJson() : null;
        json.mobileTitleMedia = this.mobileTitleMedia ? this.mobileTitleMedia.toJson() : null;
        return json;
    }
}
